<fullscreen-page>
  <navigation-column>
    <div slot="content" class="h-100 p-2">
      <div class="h-100 w-100 mx-auto">
        <dx-data-grid id="gridContainer"
                      class="h-100"
                      [dataSource]="validFeatureSystems"
                      [hoverStateEnabled]="true"
                      [showBorders]="true"
                      [selectedRowKeys]="[]"
                      [allowColumnReordering]="true"
                      [rowAlternationEnabled]="true"
                      (onRowClick)="onRowClick($event)">
          <dxo-selection mode="single"></dxo-selection>
          <dxo-filter-row [visible]="true"></dxo-filter-row>
          <dxo-header-filter [visible]="false" [allowSearch]="true"></dxo-header-filter>
          <dxo-search-panel [visible]="true" [highlightCaseSensitive]="true" placeholder="{{ 'Featuresystem suchen' | translate }}" width="250"></dxo-search-panel>
          <dxo-group-panel [visible]="false"></dxo-group-panel>
          <dxo-paging [enabled]="false"></dxo-paging>
          <dxo-scrolling mode="virtual" showScrollbar="always"></dxo-scrolling>
          <dxi-column dataField="name" caption="{{ 'Name' | translate }}"></dxi-column>
        </dx-data-grid>
      </div>
    </div>
  </navigation-column>
  <content-column>
    <div slot="content" class="h-100 d-flex flex-column">
      <div class="dx-fieldset">
        <div class="dx-field">
          <h4>{{ selectedValidFeatureSystem.name }}</h4>
        </div>
      </div>
      <validFeature [ValidFeatures]="validFeatures" class="flex-fill overflow-hidden"></validFeature>
    </div>
  </content-column>
</fullscreen-page>
